import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const NAV = [
  { to: '/admin', end: true, label: 'Dashboard',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg> },
  { to: '/admin/courses', label: 'Courses',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" /></svg> },
  { to: '/admin/instructors', label: 'Instructors',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> },
  { to: '/admin/majors', label: 'Majors',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M7 7h10M7 12h10M7 17h6M3 7h.01M3 12h.01M3 17h.01" /></svg> },
  { to: '/admin/sessions', label: 'Sessions',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg> },
  { to: '/admin/bookings', label: 'Bookings',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg> },
  { to: '/admin/orders', label: 'Orders',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg> },
  { to: '/admin/questions', label: 'Q&A',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 4v-4z" /></svg> },
  { to: '/admin/users', label: 'Users',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5.13a4 4 0 11-8 0 4 4 0 018 0zm6 0a4 4 0 11-8 0 4 4 0 018 0z" /></svg> },
  { to: '/admin/analytics', label: 'Analytics',
    icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg> },
] as const;

const cls = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-semibold transition-colors ${
    isActive
      ? 'bg-yellow-400/10 text-yellow-400 border border-yellow-400/20'
      : 'text-[#71717A] hover:text-white hover:bg-[#18181B]'
  }`;

export default function AdminShell() {
  const { user, isInstructor } = useAuth();

  // Level-2 instructors get their own scoped views; they don't manage other
  // instructors, majors, or users.
  const INSTRUCTOR_PATHS = new Set([
    '/admin', '/admin/courses', '/admin/sessions',
    '/admin/bookings', '/admin/orders', '/admin/questions', '/admin/analytics',
  ]);
  const nav = isInstructor ? NAV.filter(n => INSTRUCTOR_PATHS.has(n.to)) : NAV;

  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 flex gap-6 md:gap-8">

        {/* Sidebar */}
        <aside className="w-48 shrink-0">
          <div className="mb-2">
            <span className={`text-[10px] font-bold tracking-widest uppercase px-2.5 py-1
                             rounded-full border ${
                               isInstructor
                                 ? 'bg-yellow-400/10 text-yellow-400 border-yellow-400/20'
                                 : 'bg-red-500/10 text-red-400 border-red-500/20'}`}>
              {isInstructor ? 'Instructor' : 'Admin'}
            </span>
          </div>
          {user && (
            <div className="mb-6 px-1">
              <p className="text-[#E4E4E7] text-xs font-semibold truncate">{user.name}</p>
              <p className="text-[#52525B] text-[11px] truncate">{user.email}</p>
            </div>
          )}
          <nav className="flex flex-col gap-1">
            {nav.map(item => (
              <NavLink key={item.to} to={item.to} end={'end' in item ? item.end : false} className={cls}>
                {item.icon}{item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-8 pt-6 border-t border-[#27272A]">
            <NavLink to="/" className="flex items-center gap-2 px-4 py-2.5
                                       text-[#52525B] hover:text-[#A1A1AA] text-sm transition-colors">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back to site
            </NavLink>
          </div>
        </aside>

        {/* Content */}
        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
